import { getUserAuthValues } from '../auth'
import { getCookie } from '../browser'

export const isUserSignedIn = () => {
    let userObject = getUserAuthValues() || {}
    let usermiscVal = decodeURIComponent(getCookie('usermisc') || '').split('|')
    let signedIn = usermiscVal.includes('SIGNED_IN') && userObject.userId && userObject.userId.length > 0 ? true : false
    return signedIn
}

export const isInternalUser = () => {
    const [email] = decodeURIComponent(getCookie('userid') || '').split('|')
    const normalizedEmail = email.toLowerCase()
    return normalizedEmail.indexOf('@cleartrip') > -1 || normalizedEmail.indexOf('@flyin') > -1
}
